// extracted by mini-css-extract-plugin
module.exports = {"item":"TSZXZ","name":"PxzFR","price":"vofM+","radio":"Fh5dn"};